import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { useDispatch, useSelector } from "react-redux";
import ItemService from "../../../../services/construction_appCommonService";
import {
  addEstimation,
  addQuotationh,
  getQtnJobList,
  quotationtojob,
  setEstimationData,
} from "../../../../redux/feature/customer_app/customerV1Slice";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { formatDate } from "../../../../common/Validations";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import "../Estimation/FrontWallTable.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import DeleteQuotationJob from "../Entry/DeleteQuotationJob";
import MultiColumnFilter from "../../../../Components/Filter/MultiColumnFilter";
import SCConstants from "../../../../common/SCConstants";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import StatisticsContainer from "../../../../Components/Cards/StatisticsCardContainer";
import QuotationRevisionUpdate from "../Quotation_V1/QuotationRevisionUpdate";

const QuotationList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [modalDeleteQuotationJob, setModalDeleteQuotationJob] = useState(false);
  const [getEntryListData, setEntryListData] = useState();
  const [showStats, setShowStats] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  let qtnData = useSelector((state) => state?.customerV1?.quotation_Job);
  let quotationTable = useSelector(
    (state) => state?.customerV1?.quotation_Job?.pagination
  );
  useEffect(() => {
    if (!showStats) {
      setFilteredData(qtnData.data);
    }
  }, [showStats, qtnData]);
  const [data, setData] = useState();
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    setUserRole(userData?.roles?.[0]?.roleId || "");
  }, [userData]);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const loadQuotationData = async () => {
    setData(qtnData?.data);
  };

  const createEstimate = (qtnNo) => {
    dispatch(addQuotationh(qtnNo));
    dispatch(setEstimationData({}));
    navigate(SCConstants.CONSTRUCTION_CUSTOMER_ESTIMATE_E1);
  };
  const estimationDisplay = (documentNumber) => {
    dispatch(addEstimation(documentNumber));
    navigate(
      CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS
    );
  };
  const convertToJob = (row,) => {
    // dispatch(addEstimation(documentNumber));
    dispatch(addQuotationh(row));
    dispatch(quotationtojob("QTNTOJOB"));

    showUpdateModal("EDIT", row.documentNumber, row.revision);

  };

  //modal calling
  const showUpdateModal = () => {
    setModalUpdate(true);
  };
  const hideUpdateModal = () => {
    setModalUpdate(false);
  };

  const handleEditClick = (row) => {
    dispatch(addQuotationh(row));
    showUpdateModal("EDIT", row.documentNumber, row.revision);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_QUOTATION_LIST",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getQtnJobList(obj));
    setData(qtnData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_QUOTATION_LIST",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getQtnJobList(obj));
    setData(qtnData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_QUOTATION_LIST",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getQtnJobList(obj));
  };

  useEffect(() => {
    loadQuotationData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qtnData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_QUOTATION_LIST",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getQtnJobList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_QUOTATION_LIST",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getQtnJobList(obj));
  };

  const quotationList = [
    {
      name: "Qtn Reference Nr",
      id: "qtnReferenceNr",
      dropDown: true,
      selector: (row) => row?.qtnReferenceNr,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-warning-status">
            {row.qtnReferenceNr}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Version",
      selector: (row) => row?.version,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-success-status">
            {row.version}
          </span>
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Revision",
      selector: (row) => row.documentNumber || "--",
      cell: (row) => (
        <div>
          <button
            title="Revision"
            className="btn d-flex align-items-center w-100"
            onClick={() => handleEditClick(row.documentNumber, row.version)}
          >
            <i class="bi bi-repeat pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Version</sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Convert To Job",
      selector: (row) => row.estimationNr || row.documentNumber || "--",
      cell: (row) => {
        const isConverted = row.convertJobtStatus === "Job Converted";

        return (
          <button
            className={`btnInfo ${isConverted ? "disabledConvertBtn" : ""}`}
            disabled={isConverted}
            onClick={() => !isConverted && convertToJob(row.documentNumber, row.version)}
          >
            <i className="bi bi-repeat pe-2"></i>
          </button>
        );
      },
      sortable: true,
      width: "150px",
    },

    {
      name: "Estimate",
      selector: (row) => row.estimationNr || row.documentNumber || "--",
      sortable: true,
      cell: (row) => {
        if (row.estimationNr) {
          return (
            <button
              className="btnInfo"
              onClick={() => estimationDisplay(row.estimationNr)}
            >
              {row.estimationNr}
            </button>
          );
        } else {
          return (
            <button
              className="btnInfo"
              onClick={() => createEstimate(row.documentNumber)}
            >
              <i className="bi bi-plus-lg"></i> Create
            </button>
          );
        }
      },
      width: "180px",
    },
    {
      name: "Status",
      selector: (row) => row?.estHeaderStatus,
      cell: (row) => (
        <>
          {/* <span class="text-primary fw-bold">{row.estimationStatus}</span> */}
          <TableStatusField status={row.estHeaderStatus} />
        </>
      ),
      sortable: true,
      width: "220px",
    },

    {
      name: "Company/Client",
      selector: (row) => row.companyName,
      id: "companyName",
      dropDown: true,
      cell: (row) => (
        <div>
          <p class="">{row.companyName}</p>
          <p class="fw-bold">{row.clientName}</p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Designer",
      id: "designerName",
      dropDown: true,
      selector: (row) => row.designerName,
      cell: (row) => (
        <div>
          <p className=" ">{row.designerName} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Location",
      id: "location",
      dropDown: true,
      selector: (row) => row.location,
      cell: (row) => (
        <div>
          <p className=" ">{row.location} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Attachments",
      selector: (row) => row.supportingDoc,
      cell: (row) => (
        <>
          {row?.supportingDoc && row.supportingDoc.length > 0 ? (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.supportingDoc)}
            />
          ) : (
            "--"
          )}
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Details",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 200 }}
            overlay={
              <Tooltip
                id={`tooltip-${row.documentNumber}`}
                className="custom-tooltip"
              >
                <div style={{ textAlign: "left" }}>
                  {/* <strong>Location:</strong> {row.location} <br /> */}
                  <strong>Estimation Date:</strong>{" "}
                  {formatDate(row.tenestinationDate)} <br />
                  <strong>Building Strucutre:</strong>{" "}
                  {row?.buildingName || "--"}
                  <br />
                  <strong>Checker:</strong> {row?.checkerName || "--"}
                  <br />
                  <strong>Remarks:</strong> {row?.remarks || "--"}
                  <br />
                  <strong>Created By:</strong> {row?.createdBy || "--"}
                  <br />
                  <strong>Created Name:</strong> {row?.createdName || "--"}
                  <br />
                </div>
              </Tooltip>
            }
          >
            <button
              className="btn btn-light p-1 border-0"
              title="View Details"
            // onClick={() => handleViewDetails(row)}
            >
              <i className="bi bi-info-circle fs-5 text-primary"></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      width: "175px",
    },
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteQuotaionJob(row)}>
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      omit: userRole !== "DESIGN-MANAGER",
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Attachements",
    //   selector: (row) => row.supportingDoc,
    //   cell: (row) => (
    //     <div
    //       style={{ width: "100%" }}
    //       className="d-flex justify-content-center"
    //     >
    //       {row.supportingDoc && (
    //         <img
    //           src="assets/img/newIcons/attached-file.png"
    //           className="mt-1 attachmentIcon"
    //           alt="attachments"
    //           onClick={() => handleViewFile(row.supportingDoc)}
    //         />
    //       )}
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "160px",
    // },
  ];

  const columnsForFilter = quotationList
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  //delete
  const deleteQuotaionJob = (data) => {
    setModalDeleteQuotationJob(true);
    setEntryListData(data);
  };

  const hideModal = () => {
    setModalDeleteQuotationJob(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Quotation List</h2>
                <p className="subText">Quotation List</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={12} lg={12}>
                <Row className="align-items-end justify-content-end">
                  <Col xs="auto" className="me-2">
                    <button
                      onClick={() => setShowStats(!showStats)}
                      className="icon-btn"
                    >
                      <ChartBarIcon className="icon-svg" />
                    </button>
                  </Col>

                  <Col xs="auto" className="me-2">
                    <button
                      onClick={() => setFilterShow(!filterShow)}
                      className="icon-btn"
                    >
                      <FunnelIcon className="icon-svg" />
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
             {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.generateCustomerQuery}
                  keyName="estimationStatus"
                  paginatedList={qtnData.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                  queryName="Get_QUOTATION_LIST"
                />
              </div>
            )}
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QL</span>
                    </Col>
                    <Col xs={6} md={6} lg={6}>
                      <span className="headerTitle">Quotation List</span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>
                          <li>
                            <span>
                              <i className="bi bi-download"></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <StickyColumn
                          columnIndexes={[2, 3]}
                          leftOffsets={[0, 160, 240]}
                        />
                        <DataTable
                          title=""
                          columns={quotationList}
                          // data={data}
                          data={filteredData}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          onChangeRowsPerPage={handlePerRowsChange}
                          paginationTotalRows={quotationTable.total}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <QuotationRevisionUpdate
        show={modalUpdate}
        onHide={() => hideUpdateModal()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <DeleteQuotationJob
        show={modalDeleteQuotationJob}
        onHide={() => hideModal()}
        data={getEntryListData}
      // dropdownData={getAccountGroup}
      />
    </main>
  );
};

export default QuotationList;
